
import atlas from "@/components/atlas.vue";
import { trackLoginImpression } from '@/plugins/hwtag/events';
export default {
  data() {
    return {
      navId: 0,
      tab: 0,
      navActive:'winner',
      // 屏幕滚动
      scrollTop: 0,
      currentPage: 1,
      source: '',
      bannerH: 0,
      headerH: 0,
      WindowWidth:'',
      imgUrl: 'https://resource.xp-pen.com/img/Contest/christmasContest25/',
      sidebar: 'en',
      sliderList: [
        {
          type: 'en',
          lang: 'English',
          langText: '英语'
        },
        {
          type: 'de',
          lang: 'Deutsch',
          langText: '德语'
        },
        {
          type: 'es',
          lang: 'Español',
          langText: '西班牙语'
        },
        {
          type: 'pt',
          lang: 'Português',
          langText: '葡萄牙语'
        },
        {
          type: 'it',
          lang: 'Italiano',
          langText: '意大利语'
        },
        {
          type: 'fr',
          lang: 'Français',
          langText: '法语'
        },
        {
          type: 'jp',
          lang: '日本語',
          langText: '日语'
        },
        {
          type: 'kr',
          lang: '한국어',
          langText: '韩语'
        },
        {
          type: 'pl',
          lang: 'Polska',
          langText: '波兰语'
        },
        {
          type: 'ru',
          lang: 'Русский язык',
          langText: '俄语'
        },
        {
          type: 'id',
          lang: 'Bahasa Indonesia',
          langText: '印尼语'
        },
        {
          type: 'tw',
          lang: '繁体中文',
          langText: '繁体中文'
        }
      ],
      judgesList: [
        {
          id: 1,
          linkDomain:"https://www.youtube.com",
          linkUrl:"https://www.youtube.com/@wingedcanvas",
          name:"wingedcanvas"
        },
        {
          id: 2,
          linkDomain:"https://www.instagram.com",
          linkUrl:"https://www.instagram.com/andrea.mck_art/",
          name:"andrea2"
        },
        {
          id: 3,
          linkDomain:"https://www.youtube.com",
          linkUrl:"https://www.youtube.com/@WBA.Studio",
          name:"wisnu"
        }
      ],
      secondList: [
        {
          name:'@XFANSgms7qt6q',
          linkUrl:'https://community.xp-pen.com/gallery/40754'
        },
        {
          name:'@marcjpeg',
          linkUrl:'https://community.xp-pen.com/gallery/40897'
        },
        {
          name:'@XFANSwkzlxvr3',
          linkUrl:'https://community.xp-pen.com/gallery/40297'
        },
        {
          name:'@LiquidChimes',
          linkUrl:'https://community.xp-pen.com/gallery/40845'
        },
        {
          name:'@alorde',
          linkUrl:'https://community.xp-pen.com/gallery/40241'
        }
      ],
      thirdList: [
        {
          name:'@whitebhunny',
          linkUrl:'https://community.xp-pen.com/gallery/40932'
        },
        {
          name:'@EDDUMIC',
          linkUrl:'https://community.xp-pen.com/gallery/40785'
        },
        {
          name:'@khayala23',
          linkUrl:'https://community.xp-pen.com/gallery/40080'
        },
        {
          name:'@AungThiHan',
          linkUrl:'https://community.xp-pen.com/gallery/40454'
        },
        {
          name:'@EDELYIS',
          linkUrl:'https://community.xp-pen.com/gallery/40645'
        },
        {
          name:'@tiaf',
          linkUrl:'https://community.xp-pen.com/gallery/40466'
        },
        {
          name:'@XFANS65ojes5m',
          linkUrl:'https://community.xp-pen.com/gallery/40717'
        }
      ],
      excellentList: [
        {
          name:'@SirPaintsAlot',
          linkUrl:'https://community.xp-pen.com/gallery/40563'
        },
        {
          name:'@DRpotatoe',
          linkUrl:'https://community.xp-pen.com/gallery/40605'
        },
        {
          name:'@Cherushikyu',
          linkUrl:'https://community.xp-pen.com/gallery/40312'
        },
        {
          name:'@XFANS0lc8o50t',
          linkUrl:'https://community.xp-pen.com/gallery/40293'
        },
        {
          name:'@Clepz',
          linkUrl:'https://community.xp-pen.com/gallery/40304'
        },
        {
          name:'@XFANS2q3022tu',
          linkUrl:'https://community.xp-pen.com/gallery/40230'
        },
        {
          name:'@SoulyArtistic',
          linkUrl:'https://community.xp-pen.com/gallery/40778'
        },
        {
          name:'@Mekoyouku',
          linkUrl:'https://community.xp-pen.com/gallery/39245'
        },
        {
          name:'@Kibr',
          linkUrl:'https://community.xp-pen.com/gallery/40920'
        },
        {
          name:'@LockkHAIN',
          linkUrl:'https://community.xp-pen.com/gallery/40042'
        }
      ]
    };
  },
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: "The Magic Mirror: Journey Begins",
      meta: [
        {
          name: "keywords",
          content: "2025, XPPen, Christmas Drawing Contest, The Magic Mirror: Journey Begins",
        },
        {
          hid: "description",
          name: "names",
          content: "This Christmas, let this magic mirror be your gateway to a magical journey.We invite you to pick up your brush and depict the \"Christmas adventure through the magic mirror,\" capturing the perfect, heartwarming holiday moment shared with your elf companion.",
        },
      ],
    };
  },
  components: { atlas },
  computed: {},
  watch: {
    sidebar: {
      handler: function (val) {
        this.$i18n.locale = val
      },
      deep: true,
      immediate: true
    }

  },
  mounted() {
    this.WindowWidth = window.innerWidth;
    this.calculateBannerHeight();
    window.addEventListener('scroll', this.handleScroll, true);
    window.addEventListener('load', this.calculateBannerHeight); // Recalculate after all assets load
    window.addEventListener('resize', this.calculateBannerHeight);
    this.parametricWork();
    this.updateNavActive();
    if (this.$route.query.lang) {
      const lang = this.$route.query.lang;
      if (lang == 'hk') {
        lang = 'tw';
      }
      const langText = this.sliderList.find(item => item.type === lang)?.langText || lang;
      this.changeLanguage(lang, langText);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('load', this.calculateBannerHeight);
    window.removeEventListener('resize', this.calculateBannerHeight);
  },
  methods: {
    calculateBannerHeight() {
      if (this.$refs.bannerHeight) {
        this.bannerH = this.$refs.bannerHeight.offsetHeight;
      }
      if (document.getElementsByTagName('header')[0]) {
        this.headerH = document.getElementsByTagName('header')[0].offsetHeight;
      }
      this.updateNavActive();
    },
    // 作品方法
    async parametricWork(type, page = 1) {
      let res = await this.$global.parametricWork({ "activityId": 57, "page": page, "award": 0 });
      // res.code = '200' ? (this.source = res.result) : []
      this.source = res;
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.parametricWork(28, this.currentPage);
    },
    // 滚动方法
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.updateNavActive();
    },
    // 更新导航激活状态
    updateNavActive() {
      const sectionIds = ['winner', 'contestInfo', 'terms', 'gallery'];

      const navContent = document.getElementById('navContent');
      const navHeight = navContent ? navContent.offsetHeight : 0;
      const headerHeight = this.headerH || 0;
      const offsetThreshold = 100;

      let activeNav = '';
      const scrollPosition = this.scrollTop + navHeight + headerHeight + 1;

      for (let i = sectionIds.length - 1; i >= 0; i--) {
        const sectionElement = document.getElementById(sectionIds[i]);
        if (sectionElement) {
          const sectionTop = sectionElement.offsetTop - offsetThreshold;
          const sectionBottom = sectionElement.offsetTop + sectionElement.offsetHeight;

          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            activeNav = sectionIds[i];
            break;
          }
        }
      }
      this.navActive = activeNav;
    },
    //侧边导航锚点滚动
    handleScrollTo(id, clickType, clickName) {
      const element = document.getElementById(id);
      const navHeight = document.getElementById('navContent');
      const top = (element.getBoundingClientRect().top + window.pageYOffset) - navHeight.offsetHeight - 100;
      window.scroll({ top, behavior: 'smooth' });
      this.handleTrack(clickType, clickName, 'null', 'null');
      this.navActive = id;
      if(id === 'winner') {
        this.navId = 0;
      }else {
        this.navId = 1;
      }
    },
    //语言栏切换
    changeLanguage(lang, langText) {
      this.sidebar = lang;
      this.$loadLanguageAsync(lang);
      this.handleTrack(`点击语言${langText}`, `language-${langText}`, 'null', 'null');
    },
    //rules tab
    handelTab (tabIndex) {
      this.tab = tabIndex;
    },
    // 埋点
    handleTrack (clickType, clickName, linkDomain, linkUrl) {
      this.$track("promotion_page_click", {
        promotion_type:"2025圣诞活动",
        item_skuid:"null",
        item_sku_name:"null",
        item_sku_key_name:"null",
        link_domain:linkDomain,
        link_url:linkUrl,
        click_type:clickType,
        click_name:clickName
      })
    },
    //上传作品
    handleUpload (clickType, clickName) {
      if(!this.$store.state.isLogin) {
        trackLoginImpression('点击', '参与比赛', 'Submit your entry');
        const useNewLogin = this.$store.state.siteConfig && this.$store.state.siteConfig.DialogPassportSwitch == '1';
        if (useNewLogin) {
          this.$store.commit('OPEN_AUTH_MODAL', {
            tab: 'login',
            redirectToUserCenter: false,
            source: { elementTypeName: '参与比赛', clickName: 'Submit your entry' },
          });
        } else {
          this.$jumpTerminus(1);
        }
        this.handleTrack(clickType, clickName, 'https://account.xp-pen.com', 'https://account.xp-pen.com/login/index?jumpUrl=https://community.xp-pen.com/&lang=en')
      }else {
        this.handleTrack(clickType, clickName, 'https://community.xp-pen.com', 'https://community.xp-pen.com/releaseWork')
      }
    },
    // rules tab
    handleTab (tabIndex, clickType, clickName) {
      this.tab = tabIndex;
      this.handleTrack(clickType, clickName, 'null', 'null')
    },
  },
};
